























import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { StepConfig } from '@/store/modules/jtms/course/course.types';
import { RootState } from '@/store/store';
import { Component, Emit, Model, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import CheckoutStepperComponent from './CheckoutStepperComponent.vue';

@Component({
  components: {
    CheckoutStepperComponent
  }
})
export default class CheckoutSteps extends Vue {
  @Model('change', { type: Number }) readonly value!: number;

  @Action('shortCourseCheckout/setIsLastStep')
  setIsLastStep!: (payload: boolean) => void;

  @Getter('course/isFreeCourse')
  isFreeCourse!: boolean;

  @Getter('course/isGroupRegistrationEnabled')
  groupRegistrationEnabled!: boolean;

  @Getter('course/hasQuestionnaire')
  hasQuestionnaire!: boolean;

  @State(({ course }: RootState) => course.publicCourseState.courseDetails)
  publicCourseDetails!: PublicCourseDetails;

  // 1. Modular Labels & IDs
  // 2. Number of steps is defined by this array length
  // 3. Enable/Disable logic handled here
  get checkoutSteps(): StepConfig[] {
    return [
      {
        id: 'participants',
        label: this.groupRegistrationEnabled ? 'Participants' : 'Participant',
        clickable: false
      },
      {
        id: 'questions',
        label: 'Answer Questions',
        // JAAS-2803-TODO: Implement component logic to disable this step/make it unclickable
        // If previous step isn't done (depends on form state, not available in this
        // epic). For now, it depends only on course properties
        disabled: !this.hasQuestionnaire,
        clickable: false
      },
      {
        id: 'checkout',
        label: 'Checkout',
        // JAAS-2803-TODO: Implement component logic to disable this step/make it unclickable
        // If previous step isn't done (depends on form state, not available in this
        // epic). For now, it depends only on course properties
        disabled: this.isFreeCourse,
        clickable: false
      }
    ];
  }

  mounted() {
    this.updateStepperLastStepState();
  }

  // Additionally used to determine if the stepper component should be disabled entirely
  // i.e., if there is only one step, there is no need for the stepper
  get activeSteps(): StepConfig[] {
    return this.checkoutSteps.filter((step) => !step.disabled);
  }

  @Watch('value')
  updateStepperLastStepState() {
    let isLastStep: boolean = false;
    if (this.activeSteps.length === 1) {
      isLastStep = true;
    }

    if (this.activeSteps.length > 1) {
      isLastStep = this.value + 1 === this.activeSteps.length;
    }

    this.setIsLastStep(isLastStep);
  }

  @Emit('change')
  onStepChange(val: number) {
    return val;
  }

  @Emit('back')
  handleBack() {
    return;
  }
}
